export { default } from 'ember-colpick/components/col-pick-input';
